import React from 'react'
import PropTypes from 'prop-types'
import ServiceRow from './ServiceRow'
import { mapServiceTypeToTitle, SERVICE_HOME_SECURE, SERVICE_SPEED_BOOST } from '../constants'
import UsageRow from './UsageRow'
import ServiceRowHomeSecure from './ServiceRowHomeSecure'
import ServiceRowSpeedBoost from './ServiceRowSpeedBoost'

const ServiceRowBroadband = (props) => {
    return (
        <React.Fragment>
            <ServiceRow
                icon={`/images/icon-${props.item.type}.svg`}
                title={mapServiceTypeToTitle[props.item.type]}
                subTitle={props.item.description}
                preTitle={props.item.address}
                url={`/my-services/${props.item.type}/${props.item.id}`}
            >
                <UsageRow
                    title={props.item.usageSummary.unlimited ? 'Billing cycle ends' : 'Allowances reset'}
                    isUnlimitedUsage={false}
                    progress={props.item.billingCycleProgressPercentage}
                    summaryText={props.item.nextBillingCycleStart}
                    isDateField
                />
                {props.item.usageSummary.anytime || ('summaryText' in props.item.usageSummary)
                    ? <UsageRow
                            title='Data'
                            itemKey='data'
                            isUnlimitedUsage={props.item.usageSummary.unlimited}
                            showUnlimitedUsage
                            progress={props.item.usageSummary.usagePercentage}
                            summaryText={props.item.usageSummary.summaryText}
                            isLastItem
                      />
                    : ''}
                {!props.item.usageSummary.anytime && props.item.usageSummary.peak
                    ? <UsageRow
                            title='Peak data'
                            itemKey='data'
                            isUnlimitedUsage={props.item.usageSummary.unlimited}
                            progress={props.item.usageSummary.peak.usagePercentage}
                            summaryText={props.item.usageSummary.peak.summaryText}
                      />
                    : ''}
                {!props.item.usageSummary.anytime && props.item.usageSummary.offPeak
                    ? <UsageRow
                            title='Off-peak data'
                            itemKey='data'
                            isUnlimitedUsage={props.item.usageSummary.unlimited}
                            progress={props.item.usageSummary.offPeak.usagePercentage}
                            summaryText={props.item.usageSummary.offPeak.summaryText}
                            isLastItem
                      />
                    : ''}
            </ServiceRow>
            {props.item.services.map((item, key) => {
                if (item.type === SERVICE_HOME_SECURE) {
                    return <ServiceRowHomeSecure key={key} item={item} />
                } else if (item.type === SERVICE_SPEED_BOOST) {
                    return <ServiceRowSpeedBoost key={key} item={item} />
                }
            })}
        </React.Fragment>
    )
}

ServiceRowBroadband.propTypes = {
    item: PropTypes.shape({
        type: PropTypes.string,
        description: PropTypes.string,
        address: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        usageSummary: PropTypes.object,
        unlimited: PropTypes.bool,
        services: PropTypes.array
    }).isRequired
}

export default ServiceRowBroadband



// WEBPACK FOOTER //
// ./resources/js/components/ServiceRowBroadband.js